import React from "react";
import PropTypes from "prop-types";
import FloatingActionButton from "./FloatingActionButton";
import {
  PhoneIcon,
  ContactsIcon,
  CampaignsIcon,
  DealsIcon,
  ReportsIcon,
  AddIcon,
} from "../icons";

const SpeedDial = ({
  position = "bottom-right",
  glassMorphism = true,
  disabled = false,
  onNavigate,
}) => {
  const speedDialActions = [
    {
      id: "new-call",
      icon: PhoneIcon,
      tooltip: "New Call",
      color: "success",
      onClick: () => onNavigate("/dialer"),
    },
    {
      id: "new-contact",
      icon: ContactsIcon,
      tooltip: "New Contact",
      color: "primary",
      onClick: () => onNavigate("/contacts/new"),
    },
    {
      id: "new-campaign",
      icon: CampaignsIcon,
      tooltip: "New Campaign",
      color: "secondary",
      onClick: () => onNavigate("/campaigns/new"),
    },
    {
      id: "new-deal",
      icon: DealsIcon,
      tooltip: "New Deal",
      color: "primary",
      onClick: () => onNavigate("/deals/new"),
    },
    {
      id: "reports",
      icon: ReportsIcon,
      tooltip: "View Reports",
      color: "secondary",
      onClick: () => onNavigate("/reports"),
    },
  ];

  return (
    <FloatingActionButton
      icon={AddIcon}
      position={position}
      color="primary"
      size="large"
      speedDial
      speedDialActions={speedDialActions}
      glassMorphism={glassMorphism}
      disabled={disabled}
      tooltip="Quick Actions"
    />
  );
};

SpeedDial.propTypes = {
  position: PropTypes.oneOf([
    "bottom-right",
    "bottom-left",
    "top-right",
    "top-left",
  ]),
  glassMorphism: PropTypes.bool,
  disabled: PropTypes.bool,
  onNavigate: PropTypes.func.isRequired,
};

export default SpeedDial;
